export interface State {
    name: string;
    label: string;
    value: string;
    states: [];
}

export interface MetadataV2Dropdown {
    name: string;
    description: string;
}

export interface ContractorStatusArray {
    label: string;
    value: string;
}

export interface StateOptions {
    label: string;
    value: string;
}

export enum DocumentTypeFilterOptions {
    ContractorCompany = 'CONTRACTOR_COMPANY',
    ContractorTeam = 'CONTRACTOR_TEAM',
}

export enum QualificationSubTypes {
    LICENSE = 'License',
}

export interface ContractorTeamFilter {
    urlFragment: string;
    noOfDocumentsToShow: number;
    contractorTeamDocumentType: string;
    contractorStatuses: string[] | null;
    page: number;
}

export interface ContractorCompanyFilter {
    urlFragment: string;
    documentType: string;
    noOfDocumentsToShow: number;
    contractorCompanyDocumentType: string;
    contractorStatuses: string[] | null;
    page: number;
}

export interface DoughnutOptions {
    plugins: {
        legend: {
            display: boolean;
            labels: {
                boxWidth: number;
                font: {
                    weight: string;
                };
                generateLabels:
                    | {
                          fontColor: string;
                          text: string;
                          fillStyle: string;
                          datasetIndex: number;
                      }
                    | any;
            };
        };
        tooltip:
            | {
                  bodyAlign: string;
                  callbacks: {
                      label: string;
                  };
              }
            | any;
    };
    spacing: number;
    cutout: string;
}

export interface BarOptions {
    scales: {
        x: {
            grid: {
                display: boolean;
            };
        };
        y: {
            beginAtZero: boolean;
        };
    };
    plugins: {
        datalabels: {
            anchor: string;
            align: string;
            offset: number;
            font: {
                size: number;
                weight: string;
            };
            color: string | any;
        };
        legend: {
            display: false;
        };
        tooltip: {
            bodyAlign: string;
        };
    };
}
